import {createStore,applyMiddleware,compose} from 'redux'
import rootReducer from './reducers'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './sagas'
import {persistCombineReducers} from 'redux-persist'
import storage from 'redux-persist/es/storage'

const win = window;
const sagaMiddleware = createSagaMiddleware();
const middlewares = [];

let storeEnhancers ;
if(process.env.NODE_ENV==='production'){
    storeEnhancers = compose(
        applyMiddleware(...middlewares,sagaMiddleware)
    );
}else{
    storeEnhancers = compose(
        applyMiddleware(...middlewares,sagaMiddleware),
        (win && win.devToolsExtension) ? win.devToolsExtension() : (f) => f,
    );
}

export default function configureStore(initialState={}) {
    const config = {
        key: 'root',
        storage
    }
    let reducer = persistCombineReducers(config, rootReducer)
    const store = createStore(reducer, initialState,storeEnhancers);
    sagaMiddleware.run(rootSaga);
    if (module.hot && process.env.NODE_ENV!=='production') {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept( './reducers',() => {
            let nextRootReducer = require('./reducers/index');
            let persistReducer = persistCombineReducers(config, nextRootReducer)
            store.replaceReducer(persistReducer);
        });
    }
    return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.js